var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-layout wrap"
  }, [_c('p', {
    staticClass: "container-tit"
  }, [_vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n  ")]), _vm._v(" "), _c('Divider'), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-625e8fd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Layout/baseLayout.vue
// module id = hKmG
// module chunks = 142